// Centralized curriculum data structure
// ============================================
// FILE: QuestionsList.js
// Complete Data Structure for Unit Planning
// ============================================
import grade_0 from "./grades/grade_0";
import grade_1 from "./grades/grade_1";
import grade_2 from "./grades/grade_2";
import grade_3 from "./grades/grade_3"; 
import grade_4 from "./grades/grade_4";
import grade_5 from "./grades/grade_5";
import grade_6 from "./grades/grade_6";
import grade_7 from "./grades/grade_7";
import grade_8 from "./grades/grade_8";
import grade_9 from "./grades/grade_9";
import grade_10 from "./grades/grade_10";
import grade_11 from "./grades/grade_11";
import grade_12 from "./grades/grade_12";



// Centralized curriculum data structure



export const CurriculumData = {
   
  
  grade_0: grade_0,
  grade_1: grade_1,
  grade_2: grade_2,
  grade_3: grade_3,
  grade_4: grade_4,
  grade_5: grade_5, 
  grade_6: grade_6,
  grade_7: grade_7,
  grade_8: grade_8,
  grade_9: grade_9,
  grade_10: grade_10,
  grade_11: grade_11,
  grade_12: grade_12,




};

// Helper function to generate grade options (ONLY Grade → Subject, no topics)
export const generateGradeOptions = () => {
  return Object.keys(CurriculumData).map(gradeKey => ({
    value: gradeKey,
    label: CurriculumData[gradeKey].label,
    children: Object.keys(CurriculumData[gradeKey].subjects).map(subjectKey => ({
      value: subjectKey,
      label: CurriculumData[gradeKey].subjects[subjectKey].label
      // NO children here - only 2 levels: Grade → Subject
    }))
  }));
};

// console.log(...generateGradeOptions)
// console.log(...generateGradeOptions)




// Helper function to get competencies based on grade and subject selection
export const getCompetenciesForSelection = (gradeValue, subjectValue) => {
  if (!gradeValue || !subjectValue) return [];

  const gradeData = CurriculumData[gradeValue];
  if (!gradeData) return [];

  const subjectData = gradeData.subjects[subjectValue];
  if (!subjectData || !subjectData.competencies) return [];

  // Return core competencies with their sub-competencies as children
  return subjectData.competencies.core.map(coreComp => ({
    value: coreComp.value,
    label: coreComp.label,
    children: (subjectData.competencies.sub[coreComp.value] || []).map(subComp => ({
      value: subComp.value,
      label: subComp.label
    }))
  }));
};

// Updated Unit Questions List
export const UnitQuestionsList = [
  {
    question: "For which grade and subject do you want to create the unit?",
    important: "true",
    type: "nested_select",
    key: "grade_subject_selection",
    options: generateGradeOptions()
  },
  {
    question: "What curriculum competencies are you expecting students to practice or master?",
    important: "true",
    type: "multi_select_nested",
    dependsOn: "grade_subject_selection",
    key: "competency_selection",
    options: [], // Will be populated dynamically
    multiSelect: true // Allow multiple selections
  },
  // {
  //   question: "This unit will be _____ lessons over _____ weeks.",
  //   important: "false",
  //   type: "text_input",
  //   key: "unit_duration"
  // },

  // {
  //   question: "What is the main focus or theme of this unit?",
  //   important: "true",
  //   type: "text_input",
  //   key: "unit_theme"
  // },

  // {
  //   question: "What prior knowledge should students have?",
  //   important: "false",
  //   type: "text_input",
  //   key: "prior_knowledge"
  // },

  // {
  //   question: "What are the learning objectives for this unit?",
  //   important: "true",
  //   type: "text_input",
  //   key: "learning_objectives"
  // }

];

export const LessonQuestionsList = [
  {
    question: "For which grade and subject do you want to create the Lesson?",
    important: "true",
    type: "nested_select",
    key: "grade_subject_selection",
    options: generateGradeOptions()
  },
  {
    question: "What curriculum competencies are you expecting students to practice or master?",
    important: "true",
    type: "multi_select_nested",
    dependsOn: "grade_subject_selection",
    key: "competency_selection",
    options: [], // Will be populated dynamically
    multiSelect: true // Allow multiple selections
  },
  // {
  //   question: "This unit will be _____ lessons over _____ weeks.",
  //   important: "false",
  //   type: "text_input",
  //   key: "unit_duration"
  // },

  // {
  //   question: "What is the main focus or theme of this unit?",
  //   important: "true",
  //   type: "text_input",
  //   key: "unit_theme"
  // },

  // {
  //   question: "What prior knowledge should students have?",
  //   important: "false",
  //   type: "text_input",
  //   key: "prior_knowledge"
  // },

  // {
  //   question: "What are the learning objectives for this unit?",
  //   important: "true",
  //   type: "text_input",
  //   key: "learning_objectives"
  // }

];


const questionsListExports = {
  CurriculumData,
  UnitQuestionsList,
  // LessonQuestionsList,
  // AssessmentQuestionsList,
  // LearningSupports,
  generateGradeOptions,
  getCompetenciesForSelection
};
export default questionsListExports;

// export const LessonQuestionsList = [
//   {
//     question: "What unit or topic is this lesson part of?"
//     , important: "true"
//   },
//   {
//     question: "For which grade do you want to create the lesson?",
//     important: "true"
//   },

//   {
//     // question:"What are the learning target/goal(s) for this lesson? "
//     question: "What are the specific learning targets or goals students should achieve by the end of this lesson?"

//     , important: "true"
//   },


//   {
//     question: "Which curricular competencies do you want the students to practice? "
//     , important: "true"
//   },
//   {
//     question: "What character attributes or learning habits do you want students to practice in this lesson? "
//     , important: "true"
//   }
//   , {
//     question: "Are there core texts or resources you want to incorporate into this lesson?"
//     , important: "false"
//   },

//   {
//     question: "What background knowledge do you want students to access? "
//     , important: "false"
//   },
//   {
//     // question:"What learning supports need to be incorporated into the lesson? "
//     question: "What learning supports should be incorporated into the lesson to ensure all students can access and engage with the content?"

//     , important: "false"
//   },
//   {
//     // question:"What ideas do you have for checking for understanding?"  
//     question: "How will you assess whether students are understanding the content throughout the lesson?"

//     , important: "false"
//   }

// ];



export const AssignmentsQuestionsList = [
  {
    question: "📚 What subject is the assignment for?",
    placeholder: "E.g. Math, Science, Literature",
  },
  {
    question: "For which grade do you want to create the assignment?",
    important: "true"
  },

  {
    question: "🎓 What grade level is this assignment intended for?",
    placeholder: "E.g. Grade 3, Middle School, High School",
  },
  {
    question: "💡 What is the main objective or learning outcome of the assignment?",
    placeholder: "E.g. Understand fractions, Analyze weather patterns",
  },
  {
    question: "📅 What is the expected duration to complete this assignment?",
    placeholder: "E.g. 1 Day, 1 Week, Over the Weekend",
  },
  {
    question: "🙏 How would you like to integrate a biblical worldview or values?",
    placeholder: "E.g. Connect the task to stewardship, integrity, compassion",
  }
];


export const AssessmentQuestionsList = [
  {
    question: "Is this a formative or a summative assessment?"
    , important: "true"
  },
  {
    question: "For which grade do you want to create the assessment?",
    important: "true"
  },
  {
    question: "What skills and knowledge would you like to assess?"
    , important: "true"
  },
  {
    // question:"What success criteria do you have for this assessment?" 
    question: "What does success look like for students on this assessment?"

    , important: "true"
  },
  {
    question: "How are you going to use the results?"
    , important: "false"
  },
  {
    question: "What character attributes do you hope to have students practice while completing this assessment?"
    , important: "false"
  },

];

// Maps API/backend designation strings to our category_funding option labels (for autofill).
// Keys are normalized (lowercase, trimmed); value is the exact label used in categoryOptions.
export const DESIGNATION_CATEGORY_ALIASES = {
  "behaviour intervention/mental illness": "H – Behaviour / Mental Health",
  "behaviour intervention / mental illness": "H – Behaviour / Mental Health",
  "behaviour/mental health": "H – Behaviour / Mental Health",
  "behaviour / mental health": "H – Behaviour / Mental Health",
  "behaviour/mental illness": "H – Behaviour / Mental Health",
  "behaviour / mental illness": "H – Behaviour / Mental Health",
  "mental health": "H – Behaviour / Mental Health",
  "mental illness": "H – Behaviour / Mental Health",
  "behaviour": "H – Behaviour / Mental Health",
  "autism spectrum disorder": "G – Autism Spectrum Disorder",
  "autism": "G – Autism Spectrum Disorder",
  "visual impairment": "E – Visual Impairment",
  "deaf / hard of hearing": "F – Deaf / Hard of Hearing",
  "deaf": "F – Deaf / Hard of Hearing",
  "hard of hearing": "F – Deaf / Hard of Hearing",
  "physical disability / chronic health": "D – Physical Disability / Chronic Health",
  "physical disability": "D – Physical Disability / Chronic Health",
  "chronic health": "D – Physical Disability / Chronic Health",
  "learning disability": "Q – Learning Disability",
  "learning disabilities": "Q – Learning Disability",
  "moderate behaviour support": "R – Moderate Behaviour Support",
  "mild intellectual disability": "K – Mild Intellectual Disability",
  "moderate to profound intellectual disability": "C – Moderate to Profound Intellectual Disability",
  "intellectual disability": "C – Moderate to Profound Intellectual Disability",
  "gifted": "P – Gifted",
  "deafblind": "B – Deafblind",
  "physically dependent": "A – Physically Dependent",
  "students requiring additional support": "U – Students Requiring Additional Support",
  "additional support": "U – Students Requiring Additional Support",
};

/**
 * Resolve API/backend designation string to the exact category option label for category_funding.
 * @param {string} extractedStr - Raw value from API (e.g. "Behaviour Intervention/Mental Illness")
 * @param {Array<{value: string, label: string}>} categoryOptions - categoryOptions from the question
 * @returns {string|null} Matching option label or null
 */
export function mapDesignationToCategoryLabel(extractedStr, categoryOptions) {
  if (!extractedStr || typeof extractedStr !== "string") return null;
  const trimmed = extractedStr.trim();
  if (!trimmed) return null;
  const normalized = trimmed.toLowerCase();
  // Exact label match
  const exact = (categoryOptions || []).find((opt) => (opt.label || "").trim().toLowerCase() === normalized);
  if (exact) return exact.label;
  // Alias map
  if (DESIGNATION_CATEGORY_ALIASES[normalized]) return DESIGNATION_CATEGORY_ALIASES[normalized];
  // Partial: alias key contained in extracted or vice versa
  for (const [aliasKey, label] of Object.entries(DESIGNATION_CATEGORY_ALIASES)) {
    if (normalized.includes(aliasKey) || aliasKey.includes(normalized)) return label;
  }
  // Option label contains extracted string or vice versa
  const byInclude = (categoryOptions || []).find(
    (opt) => (opt.label || "").toLowerCase().includes(normalized) || normalized.includes((opt.label || "").toLowerCase())
  );
  return byInclude ? byInclude.label : null;
}

export const LearningSupports = [
  // SECTION 1 — ELIGIBILITY & FUNDING GATE (Mandatory)
  {
    // section: "SECTION 1 — ELIGIBILITY & FUNDING GATE (Mandatory)",
    question: "Does this student have a formal BC Ministry designation?",
    important: "true",
    type: "radio",
    key: "designation_status",
    options: [
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" }
    ]
  },
  {
    // section: "SECTION 1 — ELIGIBILITY & FUNDING GATE (Mandatory)",
    question: "Does the student require adaptations, modifications, or more than 25 hours of remedial/specialized instruction per year?",
    important: "true",
    type: "radio",
    key: "instructional_support_check",
    dependsOn: "designation_status",
    dependsOnValue: "no",
    options: [
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" }
    ]
  },

  // SECTION 2 — DESIGNATION & ISPP VALIDATION (Mandatory)
  {
    // section: "SECTION 2 — DESIGNATION & ISPP VALIDATION (Mandatory)",
    question: "What is the student's designation category?",
    important: "true",
    type: "category_funding",
    key: "designation_category_funding",
    dependsOnOr: [
      { key: "designation_status", value: "yes" },
      { key: "instructional_support_check", value: "yes" }
    ],
    categoryOptions: [
      { value: "a", label: "A – Physically Dependent" },
      { value: "b", label: "B – Deafblind" },
      { value: "c", label: "C – Moderate to Profound Intellectual Disability" },
      { value: "d", label: "D – Physical Disability / Chronic Health" },
      { value: "e", label: "E – Visual Impairment" },
      { value: "f", label: "F – Deaf / Hard of Hearing" },
      { value: "g", label: "G – Autism Spectrum Disorder" },
      { value: "h", label: "H – Behaviour / Mental Health" },
      { value: "k", label: "K – Mild Intellectual Disability" },
      { value: "p", label: "P – Gifted" },
      { value: "q", label: "Q – Learning Disability" },
      { value: "r", label: "R – Moderate Behaviour Support" },
      { value: "u", label: "U – Students Requiring Additional Support" },
      { value: "other", label: "Other" }
    ],
    allowOther: true
  },
  {
    question: "Is this one of the designations with a specific ISPP tool?",
    helperText:
      "Code G — Autism Spectrum Disorder\nCode C — Moderate to Profound Intellectual Disability\nCode D - Physical Disabilities/Chronic Health\nCode H — Intensive Behaviour Interventions / Serious Mental Illness\nCode Q — Learning Disabilities",
    // \n(If yes, confirm ISPP completion for domain analysis; if no or not applicable, use general ISPP phases for planning. Proceed to input if completed.)",
    important: "true",
    type: "radio",
    key: "ispp_tool_validation",
    dependsOnOr: [
      { key: "designation_status", value: "yes" },
      { key: "instructional_support_check", value: "yes" }
    ],
    options: [
      { value: "yes_completed", label: "ISPP completed" },
      { value: "yes_not_completed", label: "ISPP not yet completed" },
      { value: "no_not_applicable", label: "Not applicable to this designation" }
    ]
  },

  // SECTION 3 — DOMAIN & FUNCTIONAL BASELINE (Mandatory)
  {
    // section: "SECTION 3 — DOMAIN & FUNCTIONAL BASELINE (Mandatory)",
    question: "If ISPP was completed, what are the key redacted details?",
    important: "true",
    type: "strengths_needs_table",
    key: "ispp_domain_summary",
    dependsOn: "ispp_tool_validation",
    dependsOnValue: "ispp completed",
    domains: [
      { key: "communication", name: "Communication" },
      { key: "social_emotional", name: "Social-Emotional" },
      { key: "academic", name: "Academic" },
      { key: "behaviour_self_regulation", name: "Behaviour / Self-Regulation" },
      { key: "physical_functional", name: "Physical / Functional" }
    ],
    priorityOptions: [
      { value: "A", label: "A — Mild" },
      { value: "B", label: "B — Moderate" },
      { value: "C", label: "C — Intense" }
    ],
    priorityColumnLabel: "A, B, C"
  },

  // {
  //   question: "ISPP Domain Ratings (Redacted – Level of Need)",
  //   important: true,
  //   type: "domain_ratings",
  //   key: "ispp_domain_ratings",
  //   dependsOn: "has_ispp",
  //   dependsOnValue: "yes",
  
  //   helperText: "Rate each assessed domain using anonymized ISPP levels.",
  
  //   domains: [
  //     { name: "Communication", key: "communication" },
  //     { name: "Social / Emotional", key: "social_emotional" },
  //     { name: "Cognition / Learning", key: "cognition_learning" },
  //     { name: "Adaptive / Daily Living", key: "adaptive_daily_living" },
  //     { name: "Behaviour / Self-Regulation", key: "behaviour_self_regulation" }
  //   ],
  
  //   ratingOptions: [
  //     {
  //       value: "A",
  //       label: "A — Mild",
  //       description: "Minimal impact on learning; managed with general classroom strategies"
  //     },
  //     {
  //       value: "B",
  //       label: "B — Moderate",
  //       description: "Noticeable impact; requires targeted supports"
  //     },
  //     {
  //       value: "C",
  //       label: "C — Intensive",
  //       description: "Significant impact; requires intensive, ongoing supports"
  //     }
  //   ]
  // }
  // ,// SECTION 4 — STUDENT PROFILE (Mandatory)
  {
    // section: "SECTION 4 — STUDENT PROFILE (Mandatory)",
    question: "Student First Name/Last Name",
    important: "true",
    type: "text_input",
    key: "student_profile_first_last_name",
    dependsOnOr: [
      { key: "designation_status", value: "yes" },
      { key: "instructional_support_check", value: "yes" }
    ],
    placeholder: "Enter student first and last name"
  },
  {
    question: "Grade",
    important: "true",
    type: "select",
    key: "student_profile_grade",
    dependsOnOr: [
      { key: "designation_status", value: "yes" },
      { key: "instructional_support_check", value: "yes" }
    ],
    options: [
      { value: "K", label: "Kindergarten" },
      { value: "1", label: "Grade 1" },
      { value: "2", label: "Grade 2" },
      { value: "3", label: "Grade 3" },
      { value: "4", label: "Grade 4" },
      { value: "5", label: "Grade 5" },
      { value: "6", label: "Grade 6" },
      { value: "7", label: "Grade 7" },
      { value: "8", label: "Grade 8" },
      { value: "9", label: "Grade 9" },
      { value: "10", label: "Grade 10" },
      { value: "11", label: "Grade 11" },
      { value: "12", label: "Grade 12" }
    ]
  },
  {
    question: "IEP Date",
    important: "false",
    type: "text_input",
    key: "student_profile_iep_date",
    inputType: "date",
    defaultValue: "today",
    dependsOnOr: [
      { key: "designation_status", value: "yes" },
      { key: "instructional_support_check", value: "yes" }
    ],
    placeholder: "Enter IEP date"
  },
  {
    question: "Parent/Guardian Consultation",
    important: "true",
    type: "radio",
    key: "student_profile_parent_consultation",
    dependsOnOr: [
      { key: "designation_status", value: "yes" },
      { key: "instructional_support_check", value: "yes" }
    ],
    options: [
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" }
    ]
  },
  {
    question: "Parent/Guardian Consulted Date",
    important: "false",
    type: "text_input",
    key: "student_profile_parent_consulted_date",
    inputType: "date",
    dependsOnOr: [
      { key: "designation_status", value: "yes" },
      { key: "instructional_support_check", value: "yes" }
    ],
    placeholder: "Enter date consulted"
  },
  {
    question: "Was the student in attendance at the IEP meeting?",
    important: "true",
    type: "radio",
    key: "student_profile_student_attendance_iep_meeting",
    dependsOnOr: [
      { key: "designation_status", value: "yes" },
      { key: "instructional_support_check", value: "yes" }
    ],
    options: [
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" }
    ],
    helperText: "Record student attendance to support consultation and student participation in IEP development."
  },
  {
    question: "Who is on the student's support team?",
    important: "false",
    type: "checkbox",
    key: "student_profile_support_team_members",
    dependsOnOr: [
      { key: "designation_status", value: "yes" },
      { key: "instructional_support_check", value: "yes" }
    ],
    helperText:
      "Select all applicable team members. Use Other to add any additional role/person.",
    options: [
      { value: "classroom_teacher", label: "Classroom teacher" },
      { value: "learning_support_teacher", label: "Learning support teacher" },
      { value: "education_assistant", label: "EA" },
      { value: "counsellor", label: "Counsellor" },
      { value: "slp", label: "SLP" },
      { value: "ot_pt", label: "OT/PT" },
      { value: "parents_guardians", label: "Parents/Guardians" },
      { value: "community_specialists", label: "Community specialists" },
      { value: "other", label: "Other" }
    ],
    allowOther: true,
    otherPlaceholder: "Enter other team member role/person"
  },
  {
    question: "Thoughts and input from the support team",
    important: "false",
    type: "textarea",
    key: "student_profile_support_team_input",
    dependsOnOr: [
      { key: "designation_status", value: "yes" },
      { key: "instructional_support_check", value: "yes" }
    ],
    placeholder: "Summarize observations, priorities, and recommendations from team members."
  },
  {
    question: "Thoughts and input from the student",
    important: "false",
    type: "textarea",
    key: "student_profile_student_voice_input",
    dependsOnOr: [
      { key: "designation_status", value: "yes" },
      { key: "instructional_support_check", value: "yes" }
    ],
    placeholder: "Capture student voice (e.g., what I know, what I can do, what my next step is)."
  },
  {
    question: "Case Manager",
    important: "true",
    type: "text_input",
    key: "student_profile_case_manager",
    dependsOnOr: [
      { key: "designation_status", value: "yes" },
      { key: "instructional_support_check", value: "yes" }
    ],
    placeholder: "Enter case manager name"
  },
  {
    question: "Student Interests",
    important: "false",
    type: "textarea",
    key: "student_profile_interests",
    dependsOnOr: [
      { key: "designation_status", value: "yes" },
      { key: "instructional_support_check", value: "yes" }
    ],
    placeholder: "Describe student interests (e.g., hobbies, favourite subjects, activities)"
  },
  {
    question: "Student Learning Preferences",
    important: "false",
    type: "textarea",
    key: "student_profile_learning_preferences",
    dependsOnOr: [
      { key: "designation_status", value: "yes" },
      { key: "instructional_support_check", value: "yes" }
    ],
    placeholder: "Describe how the student learns best (e.g., visual, auditory, hands-on, small group)"
  },
  {
    question: "What are the student's Core Competency goals?",
    important: "true",
    type: "textarea",
    key: "student_profile_core_competency_goals",
    dependsOnOr: [
      { key: "designation_status", value: "yes" },
      { key: "instructional_support_check", value: "yes" }
    ],
    placeholder: "Describe Core Competency goals (e.g., Communication, Thinking, Personal & Social)"
  },
  {
    question: "What are the student's Curricular Competency goals?",
    important: "true",
    type: "textarea",
    key: "student_profile_curricular_competency_goals",
    dependsOnOr: [
      { key: "designation_status", value: "yes" },
      { key: "instructional_support_check", value: "yes" }
    ],
    placeholder: "Describe Curricular Competency goals (subject-area competencies)"
  },

  // SECTION 5 — STAKEHOLDER VOICE (Mandatory) - REMOVED

  // SECTION 6 — STRENGTHS & NEEDS MAPPING (Mandatory)
  // {
  //   // section: "SECTION 6 — STRENGTHS & NEEDS MAPPING (Mandatory)",
  //   question: "List the student’s strengths and needs by domain, including BC Core Competencies, with a priority level (High/Medium/Low) for each.",
  //   important: "true",
  //   type: "strengths_needs_table",
  //   key: "strengths_needs_by_domain",
  //   dependsOnOr: [
  //     { key: "designation_status", value: "yes" },
  //     { key: "instructional_support_check", value: "yes" }
  //   ],
  //   domains: [
  //     { key: "communication", name: "Communication" },
  //     { key: "social_emotional", name: "Social-Emotional" },
  //     { key: "academic", name: "Academic" },
  //     { key: "behaviour_self_regulation", name: "Behaviour / Self-Regulation" },
  //     { key: "physical_functional", name: "Physical / Functional" }
  //   ],
  //   priorityOptions: [
  //     { value: "high", label: "High" },
  //     { value: "medium", label: "Medium" },
  //     { value: "low", label: "Low" }
  //   ]
  // },

  // Learning Support Q6 — Strengths and stretches (Mandatory)
  {
    question: "What are the student's strengths and stretches?",
    important: "true",
    type: "textarea",
    key: "strengths_needs_designation_aligned",
    dependsOnOr: [
      { key: "designation_status", value: "yes" },
      { key: "instructional_support_check", value: "yes" }
    ],
    helperText:
      "Structure your response using strengths and stretches in these areas:\n- What I am able to do (Personal)\n- What I am able to do with others (Social)\n- Social domain (Social Awareness & Responsibility)\n- Academic domain (Intellectual/Learning)",
    placeholder:
      "Use strengths-and-stretches language for Personal, Social, and Academic areas."
  },

  // Learning Support Q7 — AI-generated strength-based objectives (AI fills based on accepted goals + student profile)
  {
    question: "What are strength-based objectives?",
    important: "false",
    type: "textarea",
    key: "measurable_strength_based_goals",
    aiGenerated: true,
    dependsOnOr: [
      { key: "designation_status", value: "yes" },
      { key: "instructional_support_check", value: "yes" }
    ],
    placeholder:
      "AI will draft student-specific \"By...\" objectives for accepted goals using strengths, stretches, and profile data."
  },

  // Learning Support Q10 — Add-on plans required (Mandatory)
  {
    question: "Are add-on plans required?",
    important: "true",
    type: "checkbox",
    key: "add_on_plan_requirements",
    dependsOnOr: [
      { key: "designation_status", value: "yes" },
      { key: "instructional_support_check", value: "yes" }
    ],
    // helperText: "If yes, integrate into IEP with specific strategies, e.g., de-escalation from ISPP Behaviour tool.",
    options: [
      { value: "behaviour_support", label: "Behaviour / safety plan (with safety sub-plan)" },
      { value: "safety_crisis", label: "Safety / crisis plan (crisis protocols e.g., Behaviour H)" },
      { value: "medical_care", label: "Medical care plan (Diabetes, Seizures, Allergies)" },
      { value: "intimate_care", label: "Intimate care plan" },
      { value: "transition_plan", label: "Transition plan (Grades 10–12)" },
      { value: "none", label: "None" }
    ]
  },

  // Learning Support Q11 — AI-generated supports/services (AI fills this)
  {
    question: "What supports, accommodations, strategies, and services are being utilized?",
    important: "false",
    type: "textarea",
    key: "supports_accommodations_services",
    aiGenerated: true,
    dependsOnOr: [
      { key: "designation_status", value: "yes" },
      { key: "instructional_support_check", value: "yes" }
    ],
    // placeholder: "AI will generate supports, accommodations, strategies, and services (e.g., assistive tech, small group instruction, CASEL activities, specialist involvement).",
    // helperText: "Per Manual: Include direct instruction, adaptations, specialist involvement like OT for Physical Disabilities; ensure proportionate to needs. AI generates this."
  },

  // PHASE 7 — AI AUTO-GENERATION ZONE (Informational — no form input)
  // {
  //   section: "PHASE 7 — AI AUTO-GENERATION ZONE",
  //   question: "⚙️ From here, the AI takes over",
  //   important: "false",
  //   type: "info",
  //   key: "phase_7_ai_autogeneration",
  //   dependsOnOr: [
  //     { key: "designation_status", value: "yes" },
  //     { key: "instructional_support_check", value: "yes" }
  //   ],
  //   content: [
  //     "Step 8 — Domain Alignment: Aligns strengths/needs to designation-required domains, BC Core Competencies, ISPP impairment ratings, CASEL SEL framework where applicable.",
  //     "Step 9 — Draft IEP Goals: Creates 3–5 strength-based, measurable goals with student-friendly \"I can\" statements, proficiency scale (Emerging → Extending), curriculum or modification links, and CASEL/SEL alignment."
  //   ]
  // },

  // PHASE 9 — AI SUPPORT DESIGN (Informational — no form input)
  // {
  //   section: "PHASE 9 — AI SUPPORT DESIGN",
  //   question: "⚙️ AI Generates",
  //   important: "false",
  //   type: "info",
  //   key: "phase_9_ai_support_design",
  //   dependsOnOr: [
  //     { key: "designation_status", value: "yes" },
  //     { key: "instructional_support_check", value: "yes" }
  //   ],
  //   content: [
  //     "Step 11 — Supports & Services Plan: AI builds classroom accommodations, adaptations/modifications, specialist services (OT, SLP, Behaviour Support), assistive technology, and instructional strategies tied to ISPP ratings."
  //   ]
  // },

  // PHASE 10 — PROGRESS & COMPLIANCE (Informational — no form input)
  // {
  //   section: "PHASE 10 — PROGRESS & COMPLIANCE",
  //   question: "⚙️ AI Generates",
  //   important: "false",
  //   type: "info",
  //   key: "phase_10_progress_compliance",
  //   dependsOnOr: [
  //     { key: "designation_status", value: "yes" },
  //     { key: "instructional_support_check", value: "yes" }
  //   ],
  //   content: [
  //     "Step 12 — Monitoring & Reporting Framework: AI defines evidence collection tools, observation cycles, proficiency scale tracking, report card alignment, and review schedule.",
  //     "Step 13 — Compliance Check: AI validates manual alignment, equity & cultural responsiveness, stakeholder inclusion, designation domain coverage, and funding compliance."
  //   ]
  // },

  // SECTION 8 — FINAL HUMAN APPROVAL
  // {
  //   // section: "SECTION 8 — FINAL HUMAN APPROVAL",
  //   question: "When is the next IEP review?",
  //   important: "true",
  //   type: "date_select",
  //   key: "review_scheduling",
  //   dependsOnOr: [
  //     { key: "designation_status", value: "yes" },
  //     { key: "instructional_support_check", value: "yes" }
  //   ],
  //   placeholder: "Select month and year"
  // }
];




